import logo from './logo.svg';
import {CalendarScheduler} from "./components/CalendarScheduler.js";
import './App.css';

function App() {
  return (
    <div className="App">
      <CalendarScheduler/>
    </div>
  );
}

export default App;
